import { mapToStaffPosition } from '../core/noteMapping.js';
import { getNoteType } from '../core/noteGeneration.js';



// Helper to find intensity at specific time
export const findIntensityAtTime = (intensitySegments, time) => {
  const point = intensitySegments.find(seg => Math.abs(seg.time - time) < 0.01);
  return point ? point.intensity : 0;
};

// Calculate durations between tail key points
export const calculateTailDurations = (keyPoints, tailPoints, lastMaximaTime) => {
  const keyPointsWithDurations = [];
  
  for (let i = 0; i < keyPoints.length; i++) {
    const currentPoint = keyPoints[i];
    let duration;
    
    if (i === 0) {
      // First key point: duration from last maxima to next key point (or end of tail)
      const nextPointTime = i < keyPoints.length - 1 ? keyPoints[i + 1].point.time : tailPoints[tailPoints.length - 1].time;
      duration = nextPointTime - lastMaximaTime;
    } else {
      // Subsequent key points: duration to next key point (or end of tail)
      const prevPointTime = keyPoints[i - 1].point.time;
      const nextPointTime = i < keyPoints.length - 1 ? keyPoints[i + 1].point.time : tailPoints[tailPoints.length - 1].time;
      duration = nextPointTime - prevPointTime;
    }
    
    // Ensure minimum duration
    duration = Math.max(duration, 0.1);
    
    keyPointsWithDurations.push({
      ...currentPoint,
      duration: duration
    });
  }
  
  return keyPointsWithDurations;
};

// Create individual tail point note with calculated duration
export const createTailPointNote = (point, pointType, intensity, duration, tail, segmentIndex, totalSegmentDuration, currentTime, globalMaxIntensity) => {
  const absolutePosition = (point.time / totalSegmentDuration) * 100;
  
  const { staff, noteLevel, musicalNote, frequency, line } = mapToStaffPosition(point.pitch);
  
  // Use calculated duration for tail notes
  const tailDuration = Math.min(duration, 0.5); // Cap at 0.5s max
  
  const { noteType, stemHeight, noteHeadClass } = getNoteType(
    tailDuration,
    intensity,
    globalMaxIntensity,
    false
  );
  
  const stemDirection = line < 2 ? 'up' : 'down';
  const isActive = currentTime >= point.time && currentTime <= point.time + tailDuration;

  // Determine marker and color based on point type
  let specialMarker, color;
  switch (pointType) {
    case 'tail-end':
      specialMarker = '↑';
      color = '#ff6b6b'; // Red
      break;
    case 'tail-minima':
      specialMarker = '↓';
      color = '#4dabf7'; // Blue
      break;
    case 'tail-maxima':
      specialMarker = '↑';
      color = '#51cf66'; // Green
      break;
    default:
      specialMarker = '·';
      color = '#adb5bd';
  }

  return {
    staff,
    noteLevel,
    noteType,
    stemHeight: stemHeight + 2,
    stemDirection,
    noteHeadClass: `${noteHeadClass} tail-note ${pointType}`,
    position: absolutePosition,
    duration: tailDuration,
    startTime: point.time,
    endTime: point.time + tailDuration,
    isActive,
    pitch: point.pitch,
    intensity: intensity,
    musicalNote,
    targetFrequency: frequency,
    linePosition: line,
    hasStress: false,
    isLocalMaxima: false,
    isRisingTail: true,
    tailPointType: pointType,
    segmentIndex,
    time: point.time,
    isVoiced: true,
    specialMarker: specialMarker,
    color: color
  };
};

// Export helper functions for testing
export const tailDetectionUtils = {
  findIntensityAtTime,
  calculateTailDurations,
  createTailPointNote
};